<template>
    <div class="flex flex-col gap-2" :class="div_class">
        <label class="font-medium text-primary dark:text-dark-50" :class="label_class">{{ label }}
            <span v-if="required" class="text-red-500">*</span>
        </label>
        <InputText :id="id" :type="type" :name="name" :placeholder="placeholder" :class="input_class" :value="modelValue" :disabled="disable_input" :invalid="!valid" fluid @input="$emit('update:modelValue', $event.target.value)" :min="min" :max="max" />
        <Message v-for="(item, index) in hint" :key="index" size="small" severity="secondary" variant="simple">{{ item }}
        </Message>
        <Message v-if="!valid" size="small" severity="error" variant="simple">{{ errorMessage }}
        </Message>
    </div>
</template>

<script>
import { InputText, Message } from 'primevue';

export default {
    name: 'InputTextCustom',
    props: {
        label: String,
        label_class: String,
        id: String,
        type: String,
        name: String,
        placeholder: String,
        input_class: String,
        modelValue: String,
        disable_input: Boolean,
        valid: Boolean,
        errorMessage: String,
        required: {
            type: Boolean,
            default: false
        },
        hint: Array,
        div_class: String,
        max: Number,
        min: Number,
    },
    components: {
        InputText, Message
    },
    emits: ['update:modelValue'],
}
</script>